module.exports = __webpack_public_path__ + "img/login-v2.81d3696d.svg";